
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取忌日与诞辰的集合
    GetTodayTodayDeathBirthdayList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Today/GetTodayDeathBirthdayList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
